module.exports = __webpack_public_path__ + "img/e2.d3e74a92.png";